// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import {
    getRangos as listRangosAPI,
    getRango as getRangoAPI,
    addRango as addRangoAPI,
    updateRango as updateRangoAPI,
    updateRangos as updateRangosAPI,
    deleteRango as deleteRangoAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { rangosApiResponseError, rangosApiResponseSuccess } from './actions';
import { RangosActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getRango({ payload: { id } }) {
    try {
        const response = yield call(getRangoAPI, id);
        const rangoItem = response.data.data;
        yield put(rangosApiResponseSuccess(RangosActionTypes.GET_RANGO, rangoItem));
    } catch (error) {
        yield put(rangosApiResponseError(RangosActionTypes.GET_RANGO, error));
    }
}

function* addRango({ payload: rango }) {
    try {
        const response = yield call(addRangoAPI, { ...rango })
        const rangoItem = response.data
        yield put(rangosApiResponseSuccess(RangosActionTypes.ADD_RANGO, rangoItem))
    } catch (error) {
        yield put(rangosApiResponseError(RangosActionTypes.ADD_RANGO, error))
    }
}

function* updateRango({ payload: rango }) {
    try {
        const response = yield call(updateRangoAPI, { ...rango })
        const rangoItem = response.data.data
        yield put(rangosApiResponseSuccess(RangosActionTypes.UPDATE_RANGO, rangoItem))
    } catch (error) {
        yield put(rangosApiResponseError(RangosActionTypes.UPDATE_RANGO, error))
    }
}

function* updateRangos({ payload: rangos }) {
    try {
        const response = yield call(updateRangosAPI, { ...rangos })
        const listaRangos = response.data.data;
        yield put(rangosApiResponseSuccess(RangosActionTypes.UPDATE_RANGOS, listaRangos))
    } catch (error) {
        yield put(rangosApiResponseError(RangosActionTypes.UPDATE_RANGOS, error))
    }
}

function* deleteRango({ payload: { id } }) {
    try {
        const response = yield call(deleteRangoAPI, id)
        const rangoItem = response.data.id
        yield put(rangosApiResponseSuccess(RangosActionTypes.DELETE_RANGO, rangoItem))
    } catch (error) {
        yield put(rangosApiResponseError(RangosActionTypes.DELETE_RANGO, error))
    }
}

/**
 * List contactos
 */
function* listRangos({ payload: params }) {
    try {
        const response = yield call(listRangosAPI, { ...params });
        const listaRangos = response.data.data;
        yield put(rangosApiResponseSuccess(RangosActionTypes.LIST_RANGOS, listaRangos));
    } catch (error) {
        yield put(rangosApiResponseError(RangosActionTypes.LIST_RANGOS, error));
    }
}


export function* watchGetRango(): any {
    yield takeEvery(RangosActionTypes.GET_RANGO, getRango);
}

export function* watchListRangos(): any {
    yield takeEvery(RangosActionTypes.LIST_RANGOS, listRangos);
}

export function* watchAddRango(): any {
    yield takeEvery(RangosActionTypes.ADD_RANGO, addRango)
}
export function* watchUpdateRango(): any {
    yield takeEvery(RangosActionTypes.UPDATE_RANGO, updateRango)
}

export function* watchUpdateRangos(): any {
    yield takeEvery(RangosActionTypes.UPDATE_RANGOS, updateRangos)
}

export function* watchDeleteRango(): any {
    yield takeEvery(RangosActionTypes.DELETE_RANGO, deleteRango)
}


function* rangosSaga(): any {
    yield all([
        fork(watchGetRango),
        fork(watchListRangos),
        fork(watchAddRango),
        fork(watchUpdateRango),
        fork(watchUpdateRangos),
        fork(watchDeleteRango),
    ]);
}

export default rangosSaga;
